import {Plugin} from 'prosemirror-state';
import {Decoration, DecorationSet} from 'prosemirror-view';
import {safeSlugify} from '../helper/safeSlugify';
import isEmpty from 'lodash/isEmpty';

export const headingAnchor = new Plugin({
    props: {
        decorations: state => {
            const decorations = [];
            state.doc.descendants((node, pos) => {
                if (node.type !== state.schema.nodes.heading) {
                    return;
                }

                decorations.push(Decoration.node(pos, pos + node.nodeSize, {
                        id: `${safeSlugify(node.textContent)}-${pos}`,
                    },
                ));
            });

            if (!isEmpty(decorations)) {
                document.querySelectorAll('.table-of-contents').forEach(el => {
                    el.dispatchEvent(new Event('refresh-table-of-contents'));
                })
            }

            return DecorationSet.create(state.doc, decorations);
        }
    }
});